import type { TranslatedText } from 'src/types/common';
import type { ExaminationAnswer, ExaminationQuestion } from 'src/types/examination';

import { Language } from 'src/types/common';

const languageMap: Record<string, Language> = {
  de: Language.DE,
  fr: Language.FR,
};

export function getLocalizedText(
  text: TranslatedText | undefined | null,
  language: string,
  fallbackLanguage = Language.DE
): string {
  if (!text) return '';

  const mappedLang = languageMap[language.toLowerCase()] || fallbackLanguage;

  if (text[mappedLang]) {
    return text[mappedLang];
  }

  if (text[fallbackLanguage]) {
    return text[fallbackLanguage];
  }

  return '';
}

export function getQuestionText(question: ExaminationQuestion, language: string): string {
  return getLocalizedText(question.text, language);
}

export function getAnswerText(answer: ExaminationAnswer, language: string): string {
  return getLocalizedText(answer.text, language);
}
